import React, { useState } from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { CheckCircle2, Clock, Link2, PenLine, Pencil, Trash2, Save } from "lucide-react";
import { maskCPF } from "../../lib/validators";
import { PAPEL_LABEL, fmtCPF, fmtDataHora } from "./assinaturasConst";

export const ParticipanteCard = ({ p, onAssinar, onLink, onSalvar, onRemover }) => {
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({ nome: p.nome || "", cpf: fmtCPF(p.cpf), cargo: p.cargo || "" });
  const assinado = p.status === "assinado";
  const tid = `participante-${p.papel}`;

  const salvar = async () => {
    await onSalvar(p, form);
    setEditando(false);
  };

  return (
    <Card className="p-4 space-y-2" data-testid={tid}>
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wide font-semibold" style={{ color: "#1B3A6B" }}>{PAPEL_LABEL[p.papel]}</div>
        <span className={`inline-flex items-center gap-1 text-xs font-medium ${assinado ? "text-green-700" : "text-slate-500"}`} data-testid={`${tid}-status`}>
          {assinado ? <CheckCircle2 size={13} /> : <Clock size={13} />} {assinado ? "Assinado" : "Pendente"}
        </span>
      </div>
      {editando ? (
        <div className="space-y-2">
          <Input placeholder="Nome completo" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} data-testid={`${tid}-edit-nome`} />
          <Input placeholder="CPF" value={form.cpf} onChange={(e) => setForm({ ...form, cpf: maskCPF(e.target.value) })} data-testid={`${tid}-edit-cpf`} />
          {p.papel === "contratante" && (
            <Input placeholder="Cargo" value={form.cargo} onChange={(e) => setForm({ ...form, cargo: e.target.value })} data-testid={`${tid}-edit-cargo`} />
          )}
          <Button size="sm" onClick={salvar} data-testid={`${tid}-edit-salvar`}><Save size={13} className="mr-1" /> Salvar</Button>
        </div>
      ) : (
        <div className="text-sm">
          <div className="font-medium" data-testid={`${tid}-nome`}>{p.nome || "Nome não informado"}</div>
          <div className="text-xs text-muted-foreground">
            CPF {p.cpf ? fmtCPF(p.cpf) : "não informado"}{p.cargo ? ` · ${p.cargo}` : ""}
          </div>
          {assinado && (
            <div className="text-xs text-muted-foreground mt-1" data-testid={`${tid}-protocolo`}>
              {fmtDataHora(p.assinado_em)} · {p.protocolo}
            </div>
          )}
        </div>
      )}
      {!assinado && !editando && (
        <div className="flex flex-wrap gap-2 pt-1">
          <Button size="sm" className="text-white" style={{ background: "#1B3A6B" }} onClick={() => onAssinar(p)} data-testid={`${tid}-assinar`}>
            <PenLine size={13} className="mr-1" /> Assinar agora
          </Button>
          {p.papel !== "contratante" && (
            <Button size="sm" variant="outline" onClick={() => onLink(p)} data-testid={`${tid}-link`}>
              <Link2 size={13} className="mr-1" /> Copiar link
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={() => setEditando(true)} data-testid={`${tid}-editar`} title="Editar dados">
            <Pencil size={13} />
          </Button>
          {onRemover && (
            <Button size="sm" variant="ghost" className="text-red-600" onClick={() => onRemover(p)} data-testid={`${tid}-remover`} title="Remover testemunha">
              <Trash2 size={13} />
            </Button>
          )}
        </div>
      )}
    </Card>
  );
};
